document.addEventListener('DOMContentLoaded', function() {
  var COLOR_TO_MEDIA_ID = {
    "Black":         "55725111509301",
    "Grey":          "55725173834037",
    "Black & Grey":  "55725175865653",
    "Beige":         "55725177045301",
    "Wine Red":      "55725177930037",
    "Black & Red":   "55725178618165",
    "Black & Blue":  "55725178814773",
    "Black & Beige": "55725179633973"
  };

  var observer = new MutationObserver(function() {
    document.querySelectorAll('.color-option').forEach(function(div) {
      if (div.dataset.swapFixed) return;
      div.dataset.swapFixed = '1';
      div.addEventListener('click', function() {
        var color = this.querySelector('span').textContent.trim();
        var mediaId = COLOR_TO_MEDIA_ID[color];
        if (!mediaId) return;
        var thumbItems = document.querySelectorAll('.thumbnail-list__item');
        for (var i = 0; i < thumbItems.length; i++) {
          var target = thumbItems[i].getAttribute('data-target') || '';
          if (target.endsWith('-' + mediaId)) {
            thumbItems[i].querySelector('button.thumbnail')?.click();
            break;
          }
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});